import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MeetHiszpania from "../pages/meetHiszpania/page";
import Playitas from "../pages/playitas/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MeetHiszpania />,
  },
  {
    path: "/hotel-jardin-tecina",
    element: <Home />,
  },
  {
    path: "/playitas",
    element: <Playitas />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
